import * as React from 'react';

import { Messages } from '../../../codegen/Localize';
import { SpacesSiteUrls } from '../SpacesSiteUrls';

export type ErrorType = 'default' | 'workbooks';

export interface RouterErrorProps {
  readonly errorType: ErrorType;
  readonly urls: SpacesSiteUrls;
}

// This class is meant to mimic the logic and UI in ErrorCtrl and Error.pug
export class RouterError extends React.PureComponent<RouterErrorProps> {
  public render(): JSX.Element {
    const errorState = getErrorState(this.props.errorType, this.props.urls);
    return (
     <div style={{height: 'calc(100vh - 15%)', flex: '1', position: 'relative'}}>
       <div className="tb-error-box">
        <div className="tb-error-box-message">{errorState.firstMessage}</div>
        <div className="tb-error-box-message">{errorState.secondMessage}</div>
        <a className="tb-orange-button" href={errorState.url} data-tb-test-id="button-back-to-content">
          <span>
            {errorState.urlMessage}
          </span>
        </a>
       </div>
     </div>
    );
  }
}

interface ErrorState {
  readonly firstMessage: string;
  readonly secondMessage: string;
  readonly urlMessage: string;
  readonly url: string;
}

function getErrorState(errorType: ErrorType, urls: SpacesSiteUrls): ErrorState {
  switch (errorType) {
    case 'workbooks':
      return {
        firstMessage: Messages.pageCouldNotBeAccessed(),
        secondMessage: Messages.workbookCannotBeAccessed(),
        urlMessage: Messages.backToWorkbooks(),
        url: urls.workbooksUrl()
      };
    case 'default':
    default:
      return {
        firstMessage: Messages.pageCouldNotBeAccessed(),
        secondMessage: Messages.pageDoesNotExist(),
        urlMessage: Messages.backToContent(),
        url: urls.exploreUrl()
      };
  }
}
